module.exports = __webpack_public_path__ + "static/media/attach.85c39666.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/CompanyPublic/img/attach.svg
// module id = 6959
// module chunks = 0